export interface IValidationResults {
    validation: string;
    failedRules: string;
    fileNumberId: number;
    type: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    cityOfBirth: string;
    countryOfBirth: string;
    alsoKnownAs: string;
    idNumber: string;
    socialSecurityNumber: string;
    legalName: string;
    leiRegistration: string;
    countryInc: string;
    euSecLegBasis: string;
    assessingCA: string;
    submissionDate: string;
    dateOfAssessment: string;
}

export class ValidationResults implements IValidationResults {
    validation: string;
    failedRules: string;
    fileNumberId: number;
    type: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    cityOfBirth: string;
    countryOfBirth: string;
    alsoKnownAs: string;
    idNumber: string;
    socialSecurityNumber: string;
    legalName: string;
    leiRegistration: string;
    countryInc: string;
    euSecLegBasis: string;
    assessingCA: string;
    submissionDate: string;
    dateOfAssessment: string;

    constructor() {
        this.validation = "";
        this.failedRules = "";
        this.fileNumberId = 0;
        this.type = "";
        this.firstName = "";
        this.lastName = "";
        this.dateOfBirth = "";
        this.cityOfBirth = "";
        this.countryOfBirth = "";
        this.alsoKnownAs = "";
        this.idNumber = "";
        this.socialSecurityNumber = "";
        this.legalName = "";
        this.leiRegistration = "";
        this.countryInc = "";
        this.euSecLegBasis = "";
        this.assessingCA = "";
        this.submissionDate = "";
        this.dateOfAssessment = "";
    }
}